// How each middlegame result is shown wherever it appears (the Middlegame
// results card, its legend and links): the ending results' colours, cell for
// cell, so the two pies read alike — Ahead the win green, Comeback the gold,
// Level the draw grey, Blown advantage the deep red, Behind the red-tinted
// grey. `middlegameCellText` names one start × end cell for a tooltip.
import type { MiddlegameResult, StageStanding } from '@chess/api-model';

export interface MiddlegameResultView {
  result: MiddlegameResult;
  label: string;
  /** A colour token, e.g. `var(--viz-ending-comeback)`. */
  colour: string;
  /** One sentence on the result, from the reader's side. */
  description: string;
}

export const MIDDLEGAME_RESULT_VIEWS: readonly MiddlegameResultView[] = [
  { result: 'ahead', label: 'Ahead', colour: 'var(--viz-ending-won)', description: 'The middlegame started winning or level and ended with you winning.' },
  { result: 'comeback', label: 'Comeback', colour: 'var(--viz-ending-comeback)', description: 'The middlegame started lost and ended level or with you winning.' },
  { result: 'level', label: 'Level', colour: 'var(--viz-ending-drawn)', description: 'The middlegame started level and ended level.' },
  { result: 'blown', label: 'Blown advantage', colour: 'var(--viz-ending-blown)', description: 'The middlegame started winning and ended level or lost.' },
  { result: 'behind', label: 'Behind', colour: 'var(--viz-ending-lost)', description: 'The middlegame started level or lost and ended with you lost.' },
];

/** The view of one result. */
export function middlegameResultView(r: MiddlegameResult): MiddlegameResultView {
  return MIDDLEGAME_RESULT_VIEWS.find((v) => v.result === r)!;
}

const STARTED: Record<StageStanding, string> = { winning: 'started winning', level: 'started level', lost: 'started lost' };
const ENDED: Record<StageStanding, string> = { winning: 'ended winning', level: 'ended level', lost: 'ended lost' };

/** One start × end cell in words, e.g. "started winning, ended level". */
export function middlegameCellText(start: StageStanding, end: StageStanding): string {
  return `${STARTED[start]}, ${ENDED[end]}`;
}
